import * as Yup from "yup";

import { VALIDATION_TYPES } from "@/components/Formik";
import { TLegalDocumentType } from "@/data/legal-documents";

export const createAgreementValidatorSchema = (legalDocuments: TLegalDocumentType[]) => {
  const schema = legalDocuments.reduce((previous, current: TLegalDocumentType) => {
    return {
      ...previous,
      [current]: Yup.boolean().test({ message: VALIDATION_TYPES.CHECKED, test: (value: boolean) => value }),
    };
  }, {});

  return Yup.object(schema);
};
